// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ErrorView_errorContainer__4bq9m {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
  background-color: transparent;
  transition: all 0.3s ease;
  width: 100%;
  border-radius: 8px;
  animation: ErrorView_fadeIn__Ug4Q\\+ 0.4s ease-in-out;
}

.ErrorView_fullscreen__OSACt {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  z-index: 10;
}

.ErrorView_inline__eCCoP {
  position: relative;
  min-height: 200px;
}

.ErrorView_iconWrapper__TYcQ- {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #fee2e2;
  color: #ef4444;
  margin-bottom: 1rem;
}
.ErrorView_iconWrapper__TYcQ- svg {
  font-size: 32px;
}

.ErrorView_title__qpRHC {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.5rem 0;
}

.ErrorView_message__rMLxa {
  font-size: 0.95rem;
  color: #6b7280;
  margin: 0 0 1.5rem 0;
  max-width: 400px;
  line-height: 1.5;
}

.ErrorView_retryButton__bwrgs {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.25rem;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #374151;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.ErrorView_retryButton__bwrgs:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
  transform: translateY(-1px);
}
.ErrorView_retryButton__bwrgs:active {
  transform: translateY(0);
}

@keyframes ErrorView_fadeIn__Ug4Q\\+ {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/ErrorView/ErrorView.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EAEA,oDAAA;AAAF;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AAAF;AAEE;EACE,eAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AADF;;AAIA;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,2CAAA;AADF;AAGE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;AADJ;AAIE;EACE,wBAAA;AAFJ;;AAMA;EACE;IAAO,UAAA;IAAY,2BAAA;EADnB;EAEA;IAAK,UAAA;IAAY,wBAAA;EAEjB;AACF","sourcesContent":[".errorContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 2rem;\n  background-color: transparent;\n  transition: all 0.3s ease;\n  width: 100%;\n  border-radius: 8px;\n\n  animation: fadeIn 0.4s ease-in-out;\n}\n\n.fullscreen {\n  position: absolute; \n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.95);\n  z-index: 10;\n}\n\n.inline {\n  position: relative;\n  min-height: 200px;\n}\n\n.iconWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background-color: #fee2e2;\n  color: #ef4444;\n  margin-bottom: 1rem;\n  \n  svg {\n    font-size: 32px;\n  }\n}\n\n.title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 0.5rem 0;\n}\n\n.message {\n  font-size: 0.95rem;\n  color: #6b7280;\n  margin: 0 0 1.5rem 0;\n  max-width: 400px;\n  line-height: 1.5;\n}\n\n.retryButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1.25rem;\n  background-color: #ffffff;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  color: #374151;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n\n  &:hover {\n    background-color: #f9fafb;\n    border-color: #9ca3af;\n    transform: translateY(-1px);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorContainer": `ErrorView_errorContainer__4bq9m`,
	"fadeIn": `ErrorView_fadeIn__Ug4Q+`,
	"fullscreen": `ErrorView_fullscreen__OSACt`,
	"inline": `ErrorView_inline__eCCoP`,
	"iconWrapper": `ErrorView_iconWrapper__TYcQ-`,
	"title": `ErrorView_title__qpRHC`,
	"message": `ErrorView_message__rMLxa`,
	"retryButton": `ErrorView_retryButton__bwrgs`
};
export default ___CSS_LOADER_EXPORT___;
